import jwtDecode from 'jwt-decode'
import cookies from './cookie'
import { Token } from 'types/storeTypes'

interface IAccessToken {
    ClientID: string
    PosTerminalID: string
}

export const decodeJwtToken = (token: string) => {
    return jwtDecode(token) as IAccessToken
}

/** determine current JWT token stored in cookies contain `ClientID` or not */
export const isUsingNonClientTokenType = () => {
    const token = cookies.get(Token)
    if (!token) return undefined

    return isNonClientTokenType(token)
}

export const decodeCurrentJwtToken = () => {
    return decodeJwtToken(cookies.get(Token))
}

/**
 * check token contain `ClientID` or not
 * @param token JWT accessToken to check
 */
export const isNonClientTokenType = (token: string) => {
    const decodedToken = decodeJwtToken(token)
    return decodedToken.ClientID === null || decodedToken.ClientID === undefined
}
